import { useState } from 'react';
import Hero from './components/Hero';
import Features from './components/Features';
import Segments from './components/Segments';
import SystemArchitecture from './components/SystemArchitecture';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Features />
      <Segments />
      <SystemArchitecture />
      <ContactForm />
      <Footer />
    </div>
  );
}
